const MapLegend = () => {
  return (
    <div className="leaflet-bottom leaflet-right">
      <div className="leaflet-control leaflet-bar legend-control">
        <h6>Plantation Categories</h6>
        <div className="legend-item">
          <img 
            src={process.env.PUBLIC_URL + "/assets/images/pinplantyellow.png"} 
            alt="Departmental" 
            width="20" 
            height="32"
          />
          <span>Departmental</span>
        </div>
        <div className="legend-item">
          <img 
            src={process.env.PUBLIC_URL + "/assets/images/pinplant.png"} 
            alt="Public" 
            width="20" 
            height="32"
          />
          <span>Public</span>
        </div>
      </div>
    </div>
  );
};

export default MapLegend;